import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { createModal, useModalize } from '@/components/modalize/mui'
import { Button } from '@/components/button'
import { colors } from '@/styles'
import { toast } from '@/components/toast-notifications'
import { getParams } from '@/hooks/use-search-params'
import MarkAsReadModalIcon from './mark-as-read-modal-icon.svg?react'

const MarkAsReadModalWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px;
`

const TitleWrapper = styled.h2`
  margin-top: 25px;
  font-size: 24px;
  line-height: 32px;
  font-weight: 800;
  text-align: center;
`

const TextWrapper = styled.p`
  margin-top: 25px;
  text-align: center;
  color: ${colors.grey48};
`

const ButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-around;
  gap: 10px;
`

const MarkAsReadConfirmationModal = ({
  selectedChat,
  setBulkResult,
  setIsCheckAll,
  setSelectMode
}) => {
  const { t } = useTranslation()
  const { close } = useModalize()
  const dispatch = useDispatch()
  const params = getParams(window.location.search)
  // Hack to check the state of search. TODO: fix it later
  const isSearch = !!window.location.search

  const clickHandler = async () => {
    const updatedChats = await dispatch.chat.bulkTimelineMarkAsRead({
      body: selectedChat.map(item => Number(item))
    })
    if (isSearch) setBulkResult(updatedChats.body)
    setIsCheckAll(false)

    const numberOfChats = Object.keys(updatedChats.body).length
    if (params?.unread === '1') await dispatch.chat.getTimelinesQueryString(params)

    toast(
      t(
        `b.settings.edit.marked_as_read_chat_rooms.text`,
        '{{ number }} chat(s) have been successfully marked as read!',
        { number: numberOfChats }
      ),
      {
        type: 'success'
      }
    )
    setSelectMode(false)
    close()
  }

  const clickCancelHandler = () => {
    setIsCheckAll(false)
    setSelectMode(false)
    close()
  }

  return (
    <MarkAsReadModalWrapper>
      <MarkAsReadModalIcon />
      <TitleWrapper>
        {t('b.chat.view.bulk_edit.mark_as_read_modal.title', 'Please note:')}
      </TitleWrapper>
      <TextWrapper>
        {t(
          'b.chat.view.bulk_edit.mark_as_read_modal.sub_title',
          'Marking messages as read will also update read receipts as read.'
        )}
      </TextWrapper>
      <ButtonWrapper>
        <Button theme="secondary" onClick={clickCancelHandler}>
          {t('common.cancel', 'Cancel')}
        </Button>
        <Button theme="primary" onClick={clickHandler}>
          {t('b.chat.view.bulk_edit.mark_as_read_modal.confirm', 'Got it!')}
        </Button>
      </ButtonWrapper>
    </MarkAsReadModalWrapper>
  )
}

export const showMarkAsReadConfirmationModal = createModal(MarkAsReadConfirmationModal, {
  width: '416px',
  showClose: false
})
